/* eslint-disable react/prop-types */

import ReactDOM from "react-dom";

import { IoCloseCircleSharp } from "react-icons/io5";

function BasicModal({
  children,
  isVisible = false,
  setIsVisible = () => {},
  header = "Title",
  showHeader = true,
  style = {},
}) {
  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        style={style}
        className="rounded-md bg-white p-4 flex flex-col max-h-[90vh]  overflow-hidden"
      >
        {showHeader && (
          <>
            <div className="w-full flex justify-between items-center">
              <span className="text-2xl">{header}</span>
              <span
                className="text-4xl cursor-pointer text-[rgba(0,0,0,0.4)] active:opacity-5"
                onClick={() => setIsVisible(false)}
              >
                <IoCloseCircleSharp />
              </span>
            </div>
            <Divider />
          </>
        )}

        <div className="flex-1 overflow-hidden ">{children}</div>
      </div>
    </div>,
    document.getElementById("modal-portal-root")
  );
}

function Divider() {
  return (
    <div
      className=" w-full my-2"
      style={{ height: "2px", backgroundColor: "rgba(0,0,0,0.1)" }}
    ></div>
  );
}

export default BasicModal;
